export enum EKycSteps {
  INTRO = 0,
  FORM,
  WIZARD,
  STATUS,
}
